export default [
    {
        path: `/admin/users`,
        component: () => import('@/pages/admin/Users.vue'),
        meta: {
            isVue: true,
            isLegacyRoute: true,
            sideNav: `admin`,
            feature: `vue-users`
        }
    },
    {
        path: `/admin/profile_mapping`,
        component: () => import('@/pages/admin/UserMapping.vue'),
        meta: {
            isVue: true,
            sideNav: `admin`,
            feature: [`vue-user-mapping`, `vue-users`]
        }
    },
    {
        path: `/roles`,
        redirect: `/roles/all`
    },
    {
        path: `/roles/all`,
        component: () => import('@/pages/admin/Roles.vue'),
        meta: {
            isVue: true,
            sideNav: `admin`
        }
    },
    {
        path: `/admin/members`,
        component: () => import('@/pages/Blank.vue'),
        meta: {
            isLegacyRoute: true,
            feature: `vue-users`
        }
    }
]
